module.exports = __webpack_public_path__ + "static/media/LogoMain.fc667f43.png";